import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { useEntryPoint } from '@atlassian/jira-entry-point/src/controllers/use-entry-point/index.tsx';

import { InlineCreateAdditionalFieldsEntrypoint } from '@atlassian/jira-async-inline-create-additional-fields/entrypoint.tsx';

export const useInlineIssueCreateAdditionalFieldsEntryPoint = ({
	projectKey,
	defaultAssigneeId,
}: {
	projectKey: string | null;
	defaultAssigneeId?: string;
}) => {
	const cloudId = useCloudId();

	return useEntryPoint(InlineCreateAdditionalFieldsEntrypoint, {
		cloudId,
		projectKey,
		defaultAssigneeId,
	});
};
